module.exports = __webpack_public_path__ + "img/banner2.7873d1a9.png";